<template>
  <div class="rf-setting-card border-beige-10 w-full rounded-lg border border-solid bg-white p-2.5">
    <div v-if="title" class="rf-category-header">
      <span class="rf-category-title">{{ title }}</span>
    </div>
    <div class="rf-category-content-div">
      <slot>
        <p>Place your card content here</p>
      </slot>
    </div>
  </div>
</template>

<script setup>
defineProps({ title: { type: String, default: "" } });
</script>

<style scoped>
.rf-category-header {
  padding: 0.75rem 1rem;
  font-weight: 600;
  font-size: 16px;
  border-bottom: 1px solid #ccc;
}
</style>
